module.exports = __webpack_public_path__ + "static/media/skating.63dabb08.svg";